import React, { useEffect, useState } from 'react'
import { validateFunctionalForm } from '../../../utils';
import { v2_roles } from '../../../actions/v2/masterData';

const Add = (props) => {
    const [state, setState] = useState({
        designationName: { name: 'designationName', value: props.data ? props.data.DESIGNATION_NAME : '', isRequired: true, error: '' },
        role: { name: 'role', value: props.data ? props.data.ROLE_ID : '', options: [], isRequired: true, error: '' },
        otherDetails: { name: 'otherDetails', value: props.data ? props.data.DESIGNATION_DETAIL : '', isRequired: false, error: '' },
    })
    const onChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
                error: prevState[name].isRequired && !value ? 'This field is required' : ''
            }
        }));
    };

    useEffect(() => {
        v2_roles().then((res) => {
            if (res.status) {
                setState(prevState => ({
                    ...prevState,
                    ['role']: {
                        ...prevState['role'],
                        options: res.result,
                    }
                }));
            }
        })
    }, [])
    const onSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {
                designationName: state.designationName.value,
                role: state.role.value,
                otherDetails: state.otherDetails.value,
            }
            if (props.data) {
                model.designationId = props.data.DESIGNATION_ID
            }
            props.onSubmit(model)
        }
    }
    return (
        <React.Fragment>
            <h4 className="card-title mb-4">{props.title}</h4>
            <div id="basic-example">
                <section>
                    <form onSubmit={onSubmit}>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-firstname-input">
                                        Designation {state.designationName.isRequired && <span className='text-danger'>*</span>}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="basicpill-firstname-input"
                                        placeholder="Enter Designation"
                                        name={state.designationName.name}
                                        value={state.designationName.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-firstname-input">
                                        Role {state.role.isRequired && <span className='text-danger'> *</span>}
                                    </label>
                                    <select
                                        className="form-select"
                                        id="basicpill-firstname-input"
                                        placeholder="Enter Designation"
                                        name={state.role.name}
                                        value={state.role.value}
                                        onChange={onChange}
                                    >
                                        <option value={''}>Select Role</option>
                                        {state.role.options.map((item) => {
                                            return (
                                                <option value={item.ROLE_ID}>{item.ROLE_NAME}</option>
                                            )
                                        })}
                                    </select>
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-address-input">
                                        Other Details {state.otherDetails.isRequired && <span className='text-danger'> *</span>}
                                    </label>
                                    <textarea
                                        id="basicpill-address-input"
                                        className="form-control"
                                        rows={2}
                                        placeholder="Enter Other Details"
                                        defaultValue={""}
                                        name={state.otherDetails.name}
                                        value={state.otherDetails.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <button
                                        type='submit'
                                        className="btn btn-success waves-effect btn-label waves-light me-2"
                                    >
                                        <i className="bx bx-check-double label-icon" />{" "}
                                        {props.buttonName}
                                    </button>
                                    <button
                                        type='reset'
                                        className="btn btn-danger waves-effect btn-label waves-light"
                                        onClick={() => window.history.back()}

                                    >
                                        <i className="bx bx-block label-icon " /> Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </React.Fragment>

    )
}

export default Add